<template>
  <!-- mx-n2 / px-1 : 카드 사이 간격을 좁힌다 -->
  <CRow class="mx-n2">
    <CCol md="4" class="px-1">
      <!-- 나머지 카드와 높이를 맞춘다 -->
      <CCard class="h-100">
        <CCardHeader class="py-2 d-flex justify-content-between align-items-center">
          <span><BIconBellFill/> <b>최근경보</b></span>
          <BButton v-if="alerts.length!==0"
                   variant="outline-danger"
                   size="sm"
                   @click="clearAlerts">
            <BIconTrash2Fill/> <b>경보 전체 삭제</b>
          </BButton>
        </CCardHeader>
        <CCardBody class="p-2">
          <AlarmAlertList :max-height="listMaxHeight" :show-clear="false"/>
        </CCardBody>
      </CCard>
    </CCol>

    <CCol md="4" class="px-1">
      <CCard class="h-100">
        <CCardHeader class="py-2">
          <CIcon name="cil-cog" class="mr-1"/> <b>경보현황</b>
        </CCardHeader>
        <CCardBody class="p-2">
          <AlarmConfigList @select-code="onSelectEventCode"/>
        </CCardBody>
      </CCard>
    </CCol>

    <CCol md="4" class="px-1">
      <CCard class="h-100">
        <CCardHeader class="py-2">
          <BIconBellSlashFill class="mr-1"/> <b>경보지연 설정</b>
        </CCardHeader>
        <CCardBody class="p-2">
          <AlarmDelayPanel :evt-code="delayEvtCode" :table-min-height="tableMinHeight"/>
        </CCardBody>
      </CCard>
    </CCol>
  </CRow>
</template>

<script>
import AlarmAlertList from '@/views/components/alarm/AlarmAlertList';
import AlarmConfigList from '@/views/components/alarm/AlarmConfigList';
import AlarmDelayPanel from '@/views/components/alarm/AlarmDelayPanel';

export default {
  name: 'AlarmBoard',
  components: {
    AlarmAlertList,
    AlarmConfigList,
    AlarmDelayPanel,
  },
  props: {
    // 최근경보 목록 스크롤 영역 최대 높이
    listMaxHeight: { type: String, default: '420px' },
    // 알람지연 현황 테이블 최소 높이
    tableMinHeight: { type: String, default: '240px' },
  },
  data () {
    return {
      // 알람지연 카드에 넘길 선택 경보코드
      delayEvtCode: '1',
    }
  },
  computed: {
    // 최근경보 목록 (스토어 공유). 헤더의 전체삭제 버튼 노출 판단에 쓴다.
    alerts(){
      return this.$store.state.alarm.alerts;
    },
  },
  methods: {
    clearAlerts(){
      this.alerts.splice(0);
    },

    /** 경보현황에서 경보를 고르면 지연설정 카드에 반영하고 상위에도 알린다 */
    onSelectEventCode(code){
      this.delayEvtCode = code;
      this.$emit('select-code', code);
    },
  }
}
</script>
